import * as React from "react";
import { Text } from "@react-three/drei";
import { Box, Flex, useReflow } from "@react-three/flex";
import { textMeshMaterial } from "./XRImagePop";
import QuizButtonElement from "../../UI/QuizButtonElement";
import { getLanguageFile } from "../../../../common/GetLanguageFile";
import { useXRPopupStore } from "../XRHotspots";
import { useController } from "@react-three/xr";
import { Vector3 } from "three";
import { useFrame } from "@react-three/fiber";
import { useCurrentSceneStore } from "../../../../../api/Zustand";

const NavigationCheck = () => {
  const xrPop = useXRPopupStore();

  const gazeController = useController("none");
  if (xrPop.customIsOpen)
    return (
      <Flex
        scale={gazeController ? 5 : 3}
        centerAnchor
        alignItems={"center"}
        size={[2, 5, 0]}
        onUpdate={(s) => s.lookAt(0, 0, 0)}
        position={xrPop.customDir as Vector3}
        // position={pos as THREE.Vector3}
      >
        <Inner></Inner>
      </Flex>
    );
};

export default NavigationCheck;

const Inner = () => {
  const xrPop = useXRPopupStore();
  const { setCurrentSceneID } = useCurrentSceneStore();

  const reflow = useReflow();
  useFrame(reflow);

  const navigateTo = React.useCallback(
    (id: number) => {
      setCurrentSceneID(id);
      xrPop.closePop();
    },
    [setCurrentSceneID, xrPop]
  );

  const hardLock = xrPop.customHardOrSoft === 1;

  const softLock = xrPop.customHardOrSoft === 0;

  return (
    <>
      <Box centerAnchor>
        <Text
          maxWidth={25}
          renderOrder={3}
          fontWeight={800}
          material={textMeshMaterial}
        >
          {hardLock
            ? getLanguageFile("viewer.hardlock")
            : getLanguageFile("viewer.softlock")}
        </Text>
      </Box>

      <Box
        marginTop={1}
        flexDir={"row"}
        justifyContent={hardLock ? "center" : "space-between"}
        width={20}
      >
        <Box centerAnchor>
          <QuizButtonElement
            fn={() => {
              xrPop.closePop();
            }}
          >
            {getLanguageFile("generics.cancel")}
          </QuizButtonElement>
        </Box>
        {softLock && !hardLock && (
          <Box centerAnchor>
            <QuizButtonElement fn={() => navigateTo(xrPop.customTargetScene)}>
              {getLanguageFile("generics.confirm")}
            </QuizButtonElement>
          </Box>
        )}
      </Box>
    </>
  );
};
